import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LegalEntityParty } from '@types'

type StatusEntry = {
  description?: string
  statusCode?: number
}

type InitalStateType = {
  entities: LegalEntityParty[]
  isLoading: boolean
  Status?: StatusEntry
  error: null | any
  statusByRequestId?: {
    [requestId: string]: StatusEntry
  }
}

const initialState: InitalStateType = {
  entities: [],
  isLoading: false,
  Status: {},
  error: null,
  statusByRequestId: undefined
}

const slice = createSlice({
  name: 'entities',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
      state.entities = []
      state.Status = {}
    },

    // HAS ERROR
    hasError(
      state,
      action: PayloadAction<{
        Status: StatusEntry
        requestId?: string
      }>
    ) {
      state.isLoading = false
      state.error = action.payload
      state.Status = action.payload.Status

      if (action.payload.requestId && action.payload.Status) {
        state.statusByRequestId = {
          ...(state.statusByRequestId || {}),
          [action.payload.requestId]: action.payload.Status
        }
      }
    },

    // GET Legal Entities
    getAllLegalEntitiesSuccess(
      state,
      action: PayloadAction<{
        entities: LegalEntityParty[]
        Status: StatusEntry
        requestId?: string
      }>
    ) {
      state.isLoading = false
      state.entities = action.payload.entities
      state.Status = action.payload.Status
      state.error = null

      if (action.payload.requestId && action.payload.Status) {
        state.statusByRequestId = {
          ...(state.statusByRequestId || {}),
          [action.payload.requestId]: action.payload.Status
        }
      }
    },

    // CLEAR ALL
    clearAllLegalEntites(state) {
      state.isLoading = false
      state.entities = []
      state.Status = {}
      state.error = null
      state.statusByRequestId = undefined
    }
  }
})

export const {
  getAllLegalEntitiesSuccess,
  hasError,
  startLoading,
  clearAllLegalEntites
} = slice.actions

export default slice.reducer
